(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sweeps-promo-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__sweepsPromoModalBound) return;
    window.__sweepsPromoModalBound = true;

    function lockScroll(lock) {
      document.documentElement.style.overflow = lock ? 'hidden' : '';
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-spb-open]');
      if (opener) {
        var dlg = document.getElementById(opener.getAttribute('data-spb-open'));
        if (dlg && typeof dlg.showModal === 'function') { dlg.showModal(); lockScroll(true); }
        return;
      }
      var closer = e.target.closest('[data-spb-close]');
      if (closer) { var d = closer.closest('dialog'); if (d) d.close(); return; }
      if (e.target.tagName === 'DIALOG' && e.target.classList.contains('sweeps-promo-modal')) {
        e.target.close();
      }
    });

    document.addEventListener('close', function (e) {
      if (e.target.classList && e.target.classList.contains('sweeps-promo-modal')) lockScroll(false);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
